<template>
  <v-row>
    <v-col cols="12">
      <v-sheet outlined>
        <v-row class="convocation d-flex align-center pa-8">

          <v-col 
            cols="12" 
            class="pr-8 pl-8"
            v-if="!edition.edition.enable_send_convocation">
            <v-card color="error" class="pa-4">
              <h1 class="text-h6 white--text text-center">
                La convocatoria para postular la idea ya finalizo.
              </h1>
            </v-card>
          </v-col>

          <v-col>
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  class="mx-auto"
                  max-width="220"
                >
                  <v-img :src="require('@/assets/icons/upload_idea.png')"></v-img>

                  <v-fade-transition>
                    <v-overlay
                      v-if="hover"
                      absolute
                      color="#036358"
                    >
                      <v-btn
                        :to="{name: 'my-idea'}">
                        Ver más
                      </v-btn>
                    </v-overlay>
                  </v-fade-transition>
                </v-card>
              </template>
            </v-hover>
          </v-col>

          <v-col>
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  class="mx-auto"
                  max-width="220"
                >
                  <v-img :src="require('@/assets/icons/upload_team.png')"></v-img>

                  <v-fade-transition>
                    <v-overlay
                      v-if="hover"
                      absolute
                      color="#036358"
                    >
                      <v-btn
                        :to="{name: 'myTeam'}">
                        Ver más
                      </v-btn>
                    </v-overlay>
                  </v-fade-transition>
                </v-card>
              </template>
            </v-hover>
          </v-col>

          <v-col>
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  class="mx-auto"
                  max-width="220"
                  :disabled="!edition.edition.enable_send_convocation"
                >
                  <v-img :src="require('@/assets/icons/send_postulation.png')"></v-img>

                  <v-fade-transition>
                    <v-overlay
                      v-if="hover"
                      absolute
                      color="#036358"
                    >
                      <v-btn
                        @click="dialog_confirm = true">
                        Enviar
                      </v-btn>
                    </v-overlay>
                  </v-fade-transition>
                </v-card>
              </template>
            </v-hover>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>
    
    <v-dialog
      v-model="dialog"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Validando información...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_error"
      width="500">
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Atención
        </v-card-title>

        <v-card-text
          class="pt-4 pb-6"
          style="white-space: pre-line"
        >
          {{ error_message }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_confirm"
      width="500">
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Atención 
        </v-card-title>

        <v-card-text class="pt-4 pb-6">
          Estás a punto de enviar de forma definitiva la postulación. 
          Una vez que lo envíes no se podrá modificar el formulario ni 
          ningún dato de los integrantes del equipo.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="btn_sendIdea"
            @click="dialog_confirm = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="btn_sendIdea"
            @click="sendIdea"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_convocation_close"
      width="500">
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Atención 
        </v-card-title>

        <v-card-text class="pt-4 pb-6">
          La convocatoria ya se encuentra cerrada. Para consultas comunicarse a emprendedores@unl.edu.ar 
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog_convocation_close = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    name: 'convocationInProgress',
    data: () => ({
      show: false,
      dialog: false,
      dialog_confirm:false,
      dialog_convocation_close:false,
      dialog_error: false,
      error_message: null,

      loading:true,
      btn_sendIdea: false
    }),
    computed: {
      ...mapGetters([ 
          'convocation_form', 'edition'
      ])
    },
    methods:{
      async sendIdea(){
        this.btn_sendIdea = true
        try {
          await axios.put('convocation/send-idea/'+this.convocation_form.convocation_form.id ,{
            }).then((res) =>{
              console.log(res.data.data.convocation_form)
              localStorage.removeItem('convocation_form')
              localStorage.setItem('convocation_forms', res.data.data.convocation_form);

              this.$store
                .dispatch('convocationForm', {
                  convocation_form: res.data.data.convocation_form
                })

              this.dialog_confirm = false
              this.$router.push({ name: 'home'})
            })
          } catch (error) {
            this.btn_sendIdea = false
            console.log(error.response.data);     // NOTE - use "error.response.data` (not "error")
            this.error_message = error.response.data.errors.error[0]
            this.dialog_error = true
            this.dialog_confirm = false
          }
      }
    }
  }
</script>
<style>
.convocation{
  min-height: 80vh!important;
}
</style>